module.exports = __webpack_public_path__ + "Жираф.f0a34a8.png";